import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Pagination } from 'semantic-ui-react';
import { filterPropsType, filterStateType } from '../../../types';
import { wrapConsumer } from '../FilteringContextProvider';
import CommonMultipleSearchSelectionWrapper from '../../common/CommonMultipleSearchSelectionWrapper';
import { fieldKey } from '../../../constants';
import CompareRowsModal from './CompareRowsModal';

const OverviewHeader = ({
  filterState,
  handleFilterStateChanged,
  renderColumnSelector,
  renderRowComparator,
  filterProps,
  showingFilters,
  clearColumnsDefaultValues,
  setAllRowsSelected,
  selectedRows,
  entityType,
  actions
}) => {
  const [visibleFields, setVisibleFields] = useState([]);
  const [latestVisibleField, setLatestVisibleField] = useState({});

  useEffect(() => {
    if (visibleFields !== showingFilters.visibleFields) {
      let addedVisibleFilterFields = [];
      let latestFilter = showingFilters.visibleFields[showingFilters.visibleFields.length - 1];
      let columnWasAdded = visibleFields.length < showingFilters.visibleFields.length;

      if (
        columnWasAdded &&
        latestVisibleField !== latestFilter &&
        !showingFilters.visibleFieldsOriginal.includes(latestFilter)
      ) {
        addedVisibleFilterFields.push(latestFilter);

        replaceColumnWithColumns(addedVisibleFilterFields, fieldKey.GEN_HAZARD, [
          fieldKey.GEN_PHYSICAL_HAZARD,
          fieldKey.GEN_HEALTH_HAZARD,
          fieldKey.GEN_ENVIRONMENTAL_HAZARD
        ]);
        replaceColumnWithColumns(addedVisibleFilterFields, fieldKey.GEN_TRADE_CHEMICAL_NAMES, [
          fieldKey.GEN_TRADE_NAME,
          fieldKey.GEN_CHEMICAL_NAME
        ]);

        let updatedVisibleColumns = [].concat(filterState.visibleColumns);
        addedVisibleFilterFields
          .filter(c => filterProps.possibleColumnsList.map(pc => pc.key).includes(c.key))
          .forEach(c => {
            if (!filterState.visibleColumns.map(col => col.key).includes(c.key)) {
              updatedVisibleColumns.push(c);
            }
          });
        if (JSON.stringify(updatedVisibleColumns) !== JSON.stringify(filterState.visibleColumns)) {
          handleFilterStateChanged({
            visibleFields: showingFilters.visibleFields,
            visibleColumns: updatedVisibleColumns
          });
        }
        setLatestVisibleField(latestFilter);
      }
      setVisibleFields(showingFilters.visibleFields);
    }
  });

  const replaceColumnWithColumns = (columnsArray, columnToReplace, columnsToAdd) => {
    let columnToReplaceIndex = columnsArray.findIndex(f => f.value === columnToReplace);
    if (columnToReplaceIndex !== -1) {
      let splittedColumnsToAdd = filterProps.possibleColumnsList.filter(pc =>
        columnsToAdd.includes(pc.key)
      );
      columnsArray.splice(columnToReplaceIndex, 1, ...splittedColumnsToAdd);
    }
  };

  return (
    <Grid.Row columns={2} className="notPaddedSegment">
      <Grid.Column style={{ padding: '0px' }}>
        {renderColumnSelector && (
          <div className="displayInlineBlock componentWithRightMargin">
            <CommonMultipleSearchSelectionWrapper
              name="visibleColumnsSelect"
              optionsList={filterProps.possibleColumnsList}
              values={filterState.visibleColumns}
              onChange={columns => handleFilterStateChanged({ visibleColumns: columns })}
              clearDefaultValues={clearColumnsDefaultValues}
              isClearable={true}
              cleanButtonLabel="select.multiple.input.clean.all.columns"
            />
          </div>
        )}
        {renderRowComparator && (
          <div className="displayInlineBlock componentWithRightMargin">
            <CompareRowsModal
              selectedRows={selectedRows}
              entityType={entityType}
              actions={actions}
              visibleColumns={filterProps.possibleColumnsList}
              hazardList={filterProps.hazardList}
              disabled={
                Object.keys(selectedRows).length < 2 || Object.keys(selectedRows).length > 10
              }
            />
          </div>
        )}
      </Grid.Column>
      <Grid.Column style={{ padding: '0px' }}>
        <Pagination
          key="paginationHeader"
          name="paginationHeader"
          activePage={filterState.page}
          totalPages={filterProps.filteredList.totalPages}
          size="mini"
          floated="right"
          pointing
          secondary
          onPageChange={(e, data) => {
            handleFilterStateChanged({ page: data.activePage });
            setAllRowsSelected(false);
          }}
        />
      </Grid.Column>
    </Grid.Row>
  );
};

OverviewHeader.propTypes = {
  renderColumnSelector: PropTypes.bool,
  renderRowComparator: PropTypes.bool,
  filterProps: filterPropsType.isRequired,
  filterState: filterStateType.isRequired,
  handleFilterStateChanged: PropTypes.func.isRequired
};

OverviewHeader.defaultProps = {
  renderColumnSelector: true,
  renderRowComparator: false
};

export default wrapConsumer(OverviewHeader);
